import { ITEM_TEMPLATES } from "../constants";
import { useLocale } from "../../../context/LanguageContext";
import type { ItemTemplate } from "../types";

interface QuickCreateTemplatesProps {
  onSelect: (template: ItemTemplate) => void;
}

export function QuickCreateTemplates({ onSelect }: QuickCreateTemplatesProps) {
  const { t } = useLocale();
  return (
    <div>
      <h3 className="mb-2 text-sm font-medium text-muted-foreground">
        {t("rewards.quickCreate")}
      </h3>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {ITEM_TEMPLATES.map((template) => (
          <button
            key={template.name}
            type="button"
            onClick={() => onSelect(template)}
            className="group flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-left transition-all hover:border-primary/50 hover:shadow-sm"
          >
            <span className="text-xl">{template.emoji}</span>
            <div className="min-w-0 flex-1">
              <div className="truncate text-xs font-medium text-foreground group-hover:text-primary">
                {template.name}
              </div>
              <div className="text-[10px] text-muted-foreground">
                {template.koinsPrice.toLocaleString()} Koins
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
